import Phaser from 'phaser';

import { calculateSpeed, GhostAI } from './GhostAI';
import Hero from '../Hero';
import Ghost from '../Ghost';

import { tileSize } from '~/src/consts/sizes';

export default class InterceptHeroAI implements GhostAI {
	private readonly hero: Hero;
	private readonly ghost: Ghost;
	public speed = 0;

	get targetPosition() {
		return new Phaser.Math.Vector2(this.hero)
			.add(this.hero.facingVector
				.multiply(new Phaser.Math.Vector2(8 * tileSize)));
	}

	constructor(hero: Hero, ghost: Ghost) {
		this.hero = hero;
		this.ghost = ghost;
		this.speed = (calculateSpeed(this.ghost.level - 1)) * tileSize;
	}

	chooseTarget() {
		return;
	}
}
